<template>
  <validation-observer
    ref="sendMessage"
    #default="{ invalid }"
  >
    <b-form @submit.prevent="sendMessage">
      <b-row>
        <b-col cols="12">
          <b-form-group
            :label="$t('Mobile')"
            label-for="mobile"
          >
            <validation-provider
              #default="{ errors }"
              rules="required"
              :name="$t('Mobile')"
              vid="mobile"
            >
              <vue-phone-number-input
                v-model="orgMobile"
                style="direction:ltr"
                default-country-code="IR"
                name="mobile"
                :state="errors.length > 0 ? false : null"
                :placeholder="$t('Mobile')"
                :translations="{
                  countrySelectorLabel: $t('Country Code'),
                  countrySelectorError: $t('Choose a country'),
                  phoneNumberLabel: $t('Mobile'),
                  example: $t('Example')+' :'
                }"
                :dark="$store.state.appConfig.layout.skin === 'dark'"
                dark-color="#283046"
                @update="updateMobil"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group>
            <validation-provider
              #default="{ errors }"
              :name="$t('Message type')"
              vid="messageType"
              rules="required"
            >
              <v-select
                v-model="messageType"
                label="text"
                :options="messageTypes"
                :state="errors.length > 0 ? false : null"
                :placeholder="$t('Message type')"
              >
                <template #option="{ text,value,icon }">
                  <feather-icon
                    :icon="icon"
                    size="16"
                    :value="value"
                    class="align-middle mr-50"
                  />
                  <span> {{ text }}</span>
                </template>
              </v-select>
              <small class="text-danger">{{ errors[0] }}</small>
              <small
                class="text-success"
              >{{ $t('Message type like text , image,video and') }} ...</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group v-if="messageType && messageType.value !=='text'">
            <validation-provider
              #default="{ errors }"
              :name="$t('file')"
              vid="file"
              :rules="fileRules"
            >
              <b-form-file
                v-model="file"
                :accept="messageType.attachment"
                :placeholder="$t('Choose a file or drop it here')"
                :drop-placeholder="$t('Drop file here')"
              />
              <b-card-text
                v-if="file !== null"
                class="my-1"
              >
                {{ $t('Selected file') }} : <strong>{{
                  file.name | summaryText(60)
                }}</strong><br><strong>{{ $t('File size') }} : {{ file.size | humanFileSize }}</strong>
              </b-card-text>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col
          v-if="showMessageText"
          cols="12"
        >
          <b-form-group
            :label="$t('message to send')"
            label-for="h-message"
          >
            <validation-provider
              #default="{ errors }"
              rules="required"
              :name="$t('message to send')"
            >
              <b-form-textarea
                id="message_to_send"
                v-model="message"
                :placeholder="$t('message to send')"
                rows="3"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <!-- submit and reset -->
        <b-col>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            :disabled="invalid || spin"
          >
            {{ $t('send') }}
            <feather-icon
              v-if="!spin"
              icon="SendIcon"
              size="15"
            />
            <b-spinner
              v-if="spin"
              small
            />
          </b-button>
        </b-col>
      </b-row>
      <b-row v-if="spin && file !== null">
        <b-col cols="12">

          <b-progress
            :value="fileProgress"
            rtl
            max="100"
            :precision="2"
            show-value
            variant="primary"
            class="progress-bar-primary"
          />
        </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BForm, BSpinner, BButton, BFormTextarea, BFormFile, BCardText, BProgress,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'
import {
  required, fileSize, image, ext,
} from '@validations'

export default {
  name: 'SendTestMessage',
  components: {
    BRow,
    BCol,
    BFormGroup,
    BForm,
    BButton,
    BFormTextarea,
    BCardText,
    ValidationProvider,
    ValidationObserver,
    BSpinner,
    BProgress,
    vSelect,
    BFormFile,
  },
  directives: {
    Ripple,
  },
  props: {
    account: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {
      mobile: '',
      spin: false,
      isValid: false,
      message: '',
      orgMobile: '',
      messageType: {
        value: 'text',
        icon: 'FileTextIcon',
        text: this.$t('text'),
        attachment: '',
      },
      file: null,
      fileProgress: 0,
      messageTypes: [
        {
          value: 'text',
          icon: 'FileTextIcon',
          text: this.$t('text'),
        },
        {
          value: 'image',
          icon: 'ImageIcon',
          text: this.$t('image'),
          attachment: 'image/jpeg,image/png,image/jpg',
          validation: 'image:jpeg,png,jpg|file-size:30',
        },
        {
          value: 'video',
          icon: 'VideoIcon',
          text: this.$t('video'),
          attachment: 'video/mp4, video/3gpp',
          validation: 'ext:mp4,3gpp|file-size:30',
        },
        {
          value: 'audio',
          icon: 'Volume2Icon',
          text: this.$t('audio'),
          attachment: 'audio/aac, audio/mp4, audio/amr, audio/mpeg,audio/ogg; codecs=opus|file-size:30',
        },
        {
          value: 'file',
          icon: 'FilePlusIcon',
          text: this.$t('file'),
          attachment: 'file-size:50',
        },
      ],
      // validation rules
      required,
      fileSize,
      image,
      ext,
    }
  },
  computed: {
    showMessageText() {
      return this.messageType && this.messageType.value !== 'audio' && this.messageType.value !== 'file'
    },
    fileRules() {
      let rules = this.messageType.validation
      if (this.messageType.value !== 'text' && !this.file) {
        rules += '|required'
      }
      return rules
    },
  },
  methods: {
    updateMobil(e) {
      this.isValid = e.isValid
      if (e.isValid) this.mobile = e.e164
    },
    sendMessage() {
      this.$refs.sendMessage.validate()
        .then(success => {
          if (success && this.isValid) {
            this.$emit('onStartSend')
            this.spin = true
            const formData = new FormData()
            let config = {}
            formData.append('mobile', this.mobile)
            formData.append('message', this.message)
            formData.append('message_type', this.messageType.value)
            if (this.file !== null) {
              formData.append('file', this.file)
              config = {
                onUploadProgress: progressEvent => {
                  this.fileProgress = Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total,
                  )
                },
              }
            }
            this.$http.post(`accounts/${this.account.id}/send-test-message`, formData, config)
              .then(({ message }) => {
                this.message = ''
                this.file = null
                this.spin = false
                this.$emit('onEndSend')
                this.showSuccessNotification(message)
              })
              .catch(() => {
                this.spin = false
                this.$emit('onEndSend')
              })
          }
        })
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
